import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectUserType } from "store/auth/selectors";

const ProtectedRoute = ({ allowedUserTypes = [] }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userType = useSelector(selectUserType);

  if (!isAuthenticated) {
    // Redirect to login if the user is not authenticated
    return <Navigate to="/login" replace />;
  }

  if (allowedUserTypes.length > 0 && !allowedUserTypes.includes(userType)) {
    // Redirect to an unauthorized page or dashboard home if the user doesn't have access
    return <Navigate to="/dashboard/home" replace />;
  }

  // Render the child routes if authenticated and allowed
  return <Outlet />;
};

export default ProtectedRoute;